"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleRelationshipTypeEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.CircleRelationshipTypeEnum = {
    Parent: 'parent',
    Father: 'father',
    Mother: 'mother',
    Child: 'child',
    Son: 'son',
    Daughter: 'daughter',
    Spouse: 'spouse',
    Significantother: 'significantother',
    Husband: 'husband',
    Wife: 'wife',
    Sibling: 'sibling',
    Brother: 'brother',
    Sister: 'sister',
    Grandfather: 'grandfather',
    Grandmother: 'grandmother',
    Grandson: 'grandson',
    Granddaughter: 'granddaughter',
    Guardian: 'guardian',
    Stepchild: 'stepchild',
    Stepdaughter: 'stepdaughter',
    Stepson: 'stepson',
    Uncle: 'uncle',
    Aunt: 'aunt',
    Nephew: 'nephew',
    Niece: 'niece',
    Cousin: 'cousin',
    Motherinlaw: 'motherinlaw',
    Fatherinlaw: 'fatherinlaw',
    Daughterinlaw: 'daughterinlaw',
    Soninlaw: 'soninlaw',
    Sisterinlaw: 'sisterinlaw',
    Brotherinlaw: 'brotherinlaw',
    Neighbor: 'neighbor',
    Other: 'other',
};
//# sourceMappingURL=circle-relationship-type-enum.js.map